import { render, staticRenderFns } from "./TextureSettings.vue?vue&type=template&id=9d6b4fde&scoped=true&"
import script from "./TextureSettings.vue?vue&type=script&lang=ts&"
export * from "./TextureSettings.vue?vue&type=script&lang=ts&"
import style0 from "./TextureSettings.vue?vue&type=style&index=0&id=9d6b4fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6b4fde",
  null
  
)

export default component.exports